import { RegexBasedPasswordPolicy } from './RegexBasedPasswordPolicy';

export class MustContainNumbersPolicy extends RegexBasedPasswordPolicy {

    private static instance: MustContainNumbersPolicy = new MustContainNumbersPolicy();

    private constructor() {
        super(/[0-9]/);
    }

    public static getPolicy(): MustContainNumbersPolicy {
        return MustContainNumbersPolicy.instance;
    }
}
